// extracted by mini-css-extract-plugin
export default {"Title":"_Title--HdQ5z","Content":"_Content--jYRnV","WarningIcon":"_WarningIcon--RfiFT"};